import { Events } from '../events';
import { AuthHttp, JwtHelper, tokenNotExpired } from 'angular2-jwt';
import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, URLSearchParams, Response } from '@angular/http'
import { Observable } from 'rxjs/Rx';

import { CustomerModel } from './customer.model';
import { BaseService } from '../base.service';
import { AuthService } from '../../core/auth/auth.service';

@Injectable()
export class CustomerService extends BaseService {

  // TODO: create a configuration service
  //authServerUrl: string = 'http://localhost:8080/';
  //resourceServerUrl: string = 'http://localhost:9090/';
  //resourceServerUrl: string = 'http://10.0.1.161:9090/';
  //appSecret: string = 'R2FuYWxvdHRvZG86c2VjcmV0';


  customer: CustomerModel;
  jwtHelper: JwtHelper = new JwtHelper();

  refreshSubscription: any;
  //  customer: CustomerModel = null;


  constructor(
    private authHttp: AuthHttp,
    private authSvc: AuthService,
    private events: Events) {
    super();

  }

  /**
 * Se obtiene el customer
 *
 */
  public getCustomerByUsername(): Observable<CustomerModel> {
    //this.authHttp.patch
    return this.authHttp.get(this.urls.customer)
      .map(response => response.json())
      .mergeMap(customer => {
        
        return this.authSvc.setUserInfo(customer)
      })
      .catch(err => {
        if (err.status === 500)
          return Observable.throw(err.status);
        else
          return this.handleErrorAsObservable(err)
      });
  }

  saveCustomer(customer: any) {
    return this.authHttp.post(this.urls.customer, JSON.stringify(customer))
      .mergeMap(() => this.authSvc.setUserInfo(customer))
      .catch(err => {
        if (err.status === 409)
          return Observable.throw('El usuario ya se encuentra registrado');
        else
          return this.handleErrorAsObservable(err)
      });
  }

  patchCustomer(cusrtomer: any): Observable<CustomerModel>{
    return this.authHttp.patch(this.urls.updateCustomer, JSON.stringify(cusrtomer))
      .map(response => response.json())
      .catch(err => this.handleErrorAsObservable(err));
  }

  sendVerificationEmail() {
    return this.authHttp.get(this.urls.verificationEmail)
      .catch(err => this.handleErrorAsObservable(err));
  }

}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/customer/customer.service.ts